// Google Ads / GA4 tracking + UTM capture. Loads gtag only if IDs are configured
// (REACT_APP_GA4_ID / REACT_APP_GOOGLE_ADS_ID), so nothing breaks before they're set.
const GA4 = process.env.REACT_APP_GA4_ID;
const ADS = process.env.REACT_APP_GOOGLE_ADS_ID;
let inited = false;

export function initAnalytics() {
  if (inited || typeof window === "undefined") return;
  const ids = [GA4, ADS].filter(Boolean);
  if (!ids.length) return; // no IDs yet, no-op
  inited = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${ids[0]}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  ids.forEach((id) => window.gtag("config", id));
}

export function captureUTM() {
  if (typeof window === "undefined") return;
  try {
    const q = new URLSearchParams(window.location.search);
    const keys = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid"];
    const found = {};
    keys.forEach((k) => { const v = q.get(k); if (v) found[k] = v; });
    if (Object.keys(found).length) localStorage.setItem("sc_utm", JSON.stringify(found));
  } catch (e) { /* ignore */ }
}

export function getUTM() {
  try { return JSON.parse(localStorage.getItem("sc_utm") || "{}"); } catch { return {}; }
}

// Fire a conversion/interaction event to GA4/Ads (and PostHog if present).
export function track(name, params = {}) {
  try {
    const payload = { ...getUTM(), ...params };
    if (window.gtag) window.gtag("event", name, payload);
    if (window.posthog) window.posthog.capture(name, payload);
  } catch (e) { /* ignore */ }
}

// Enhanced Conversions: pass the user's email so Google can match the conversion.
export function identify(email) {
  if (!email || !window.gtag) return;
  try { window.gtag("set", "user_data", { email }); } catch (e) { /* ignore */ }
}

// Conversion values (USD), relative weights so Google Ads optimizes toward the
// most valuable actions. Import these events as conversions in Google Ads.
export const CONVERSION_VALUES = {
  rep_signup: 32,       // salesperson creates a free profile (PRIMARY for the supply campaign)
  core_complete: 22,    // salesperson completes the C.O.R.E. assessment
  job_application: 15,  // salesperson applies to a job
  biz_signup: 32,       // business creates an account
  hire_lead: 40,        // business submits a "hire closers" lead (high intent)
  job_posted: 13,       // business posts a job
  credit_purchase: 8,   // business buys credits / pays (real revenue)
};

// Fire a valued conversion event (value + currency) for Google Ads/GA4.
export function trackConversion(name, params = {}) {
  const value = params.value != null ? params.value : CONVERSION_VALUES[name];
  track(name, { currency: "USD", value, ...params });
}
